// CreateProductPage.js
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BasicDetails from './BasicDetails/BasicDetails';
import PricingDetails from './PricingDetails/PricingDetails';
import { useState } from 'react';
import ProductSpecifications from './ComponentSpecRenderer/ProductSpecification';

const CreateProductPage = () => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [productId, setProductId] = useState(null);

    const handleCategoryChange = (categoryData) => {
        setSelectedCategory(categoryData);
    };

    const handleProductCreated = (id) => {
        setProductId(id);
    };

    return (
        <>
            <Tabs
                defaultActiveKey="productDetails"
                id="uncontrolled-tab-example"
                className=""
            >
                <Tab eventKey="productDetails" title="Product Details">
                    <BasicDetails
                        onCategoryChange={handleCategoryChange}
                        onProductCreated={handleProductCreated}
                    />
                </Tab>
                <Tab eventKey="pricingDetails" title="Pricing">
                    <PricingDetails
                        selectedCategory={selectedCategory}
                        productId={productId}
                    />
                </Tab>
                <Tab eventKey="specifications" title="Components">
                    <ProductSpecifications
                        selectedCategory={selectedCategory}
                        productId={productId}
                    />
                </Tab>
            </Tabs>
        </>
    );
};

export default CreateProductPage;